module.exports = __webpack_public_path__ + "img/logo.30b48d1c.svg";